import React, { useState } from "react";
import "./styles.css";
import "./tailwind.css";
import { Navbar } from "@components/Navigation/Navbar";
import HelpButton from "@components/Common/HelpButton";
import { AdminNotice } from "@components/Settings/AdminNotice";
import { useAuth0 } from "@auth0/auth0-react";
import { isStaffEmail } from "@utils/user_utils";
import { useSelector } from "react-redux";
import { PremiumFeatureDisabled } from "@components/Common/PremiumFeatureDisabled";
import BlurredChatbot from "@components/Chatbot/blurred-chatbot.png";
import { ChatProvider } from "./context";
import ChatInterface from "./components/ChatInterface";
import ConversationSidebar from "./components/ConversationSidebar";
import ClassicChatView from "@components/Chatbot/ChatView";

const ChatViewV2: React.FC = () => {
  const { user } = useAuth0();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [useClassicView, setUseClassicView] = useState(false);

  const { dvai_enabled, team_colors } = useSelector(({ team }: any) => team?.info ?? {});

  const teamColorVars = {
    "--team-primary": team_colors?.primary ?? "#1890ff",
    "--team-font-color": team_colors?.font_colors?.[0] ?? "#ffffff",
  } as React.CSSProperties;

  const isStaff = isStaffEmail(user?.email);

  if (!dvai_enabled && !isStaff) {
    return (
      <PremiumFeatureDisabled
        bg_image={BlurredChatbot}
        feature_name={"DataViz AI"}
        info_text={<>
          This is an elite feature that will allow you to talk to your data in seconds. <br /> <br />
          If you are interested in adding this to your platform, please contact your sales rep!</>}
      />
    );
  }

  if (useClassicView) {
    return <ClassicChatView />;
  }

  return (
    <>
      <Navbar />
      <HelpButton page="Dataviz AI" />

      {(!dvai_enabled && isStaff) && (
        <div style={{ margin: "16px", maxWidth: "800px", marginLeft: "auto", marginRight: "auto" }}>
          <AdminNotice description={"Admin Notice"} />
        </div>
      )}

      <ChatProvider>
        <div className="chat-v2-page chat-v2-root" style={teamColorVars}>
          <ConversationSidebar
            collapsed={sidebarCollapsed}
            onToggleCollapse={() => setSidebarCollapsed(prev => !prev)}
            onUseClassicView={isStaff ? () => setUseClassicView(true) : undefined}
          />
          <div className="chat-v2-main-panel">
            <ChatInterface />
          </div>
        </div>
      </ChatProvider>
    </>
  );
};

export default ChatViewV2;
